import { noop } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';
import { useState, useEffect } from 'react';

import TextFieldWithLabel from '../../../../../../../primitives/form/TextField/TextField';
import { validateAField } from '../../../../utils/formTemplateValidation';

export function AddAFieldOptions(props) {
  const { options, handleChange = noop, fieldPosition, validateAllFields = false, readOnly } = props;

  const [validation, setValidation] = useState(false);

  const handleValidation = () => {
    return validateAField([{ fieldType: 'minimumOption', fieldValue: options }]);
  };

  const handleOnChange = (event, index) => {
    const values = options.map((option, i) => (i === index ? event.target.value : option));
    const valuesWithoutBlanks = values.filter((v) => v);

    handleChange(valuesWithoutBlanks, 'option');
  };

  const handleOnBlur = () => {
    setValidation(handleValidation());
  };

  const handleOnClick = () => {
    setValidation(false);
  };

  useEffect(() => {
    if (validateAllFields) {
      setValidation(handleValidation());
    }
  }, [validateAllFields]);

  return (
    <div className="addAField__options">
      {options.map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="form__group-wrapper form__group-wrapper--half-on-desktop" key={index + 1}>
          <div className="form__group">
            <TextFieldWithLabel
              showError={validation.isError}
              errorMessage={validation.errorMessage}
              fieldID={`${fieldPosition}_options_${index + 1}`}
              fieldIdentifier={`field-${fieldPosition}-option-${index + 1}`}
              fieldName={`Option ${index + 1}`}
              fieldRequired={index === 0}
              value={value}
              handleChange={(event) => handleOnChange(event, index)}
              handleClick={handleOnClick}
              handleBlur={handleOnBlur}
              disabled={readOnly}
              autoComplete="off"
            />
          </div>
        </div>
      ))}
    </div>
  );
}

AddAFieldOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func,
  fieldPosition: PropTypes.number.isRequired,
  validateAllFields: PropTypes.bool,
  readOnly: PropTypes.bool.isRequired,
};

export default AddAFieldOptions;
